export default "__VITE_ASSET__BmwO$1du__"